// extracted by mini-css-extract-plugin
module.exports = {"label":"value-or-blank-field-flex_label__3Z6bm","value":"value-or-blank-field-flex_value__138bh"};